module.exports = __webpack_public_path__ + "media/styles/images/png/circle-ex-red-on-transparent-6aa7e0aa33604580fe21dac4a706e29e.png";